export default "__VITE_ASSET__Cgpbt1$e__"